<template>
    <v-content v-if="template">
        <v-row align="center" justify="center">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование шаблона звонка" : "Создание шаблона звонка" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="back()">
                        Назад
                    </v-btn>
                </div>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                Название шаблона для рассылок
                                <v-text-field
                                    v-model="template.name"
                                    placeholder="Название"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="text-field-header">Аккаунт</p>
                                <b-field>
                                    <b-autocomplete
                                      v-model="template.account_mailer.name"
                                      clearable
                                      :data="filteredDataArray(this.mailing_accounts, template.account_mailer)"
                                      :keep-first="false"
                                      :open-on-focus="true"
                                      field="name"
                                      @select="option => (option ? template.account_mailer = option: template.account_mailer = {name: ''})">
                                      <template #empty> Нет результатов </template>
                                    </b-autocomplete>
                                </b-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="template.account_mailer.id">
                            <v-col cols="6">
                                <audioSelector :element="template.json" :account_mailer_id="template.account_mailer.id" type="record" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <ivrRepeat :element="template.json" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <TreeChart :json="template.json" />
            </v-col>
        </v-row>
        <pre>
            {{ template.json }}
        </pre>
        <v-col>
            <div class="float-right">
                <v-btn color="primary" depressed @click="saveTemplate()">
                    <v-icon small>mdi-plus</v-icon>
                    Сохранить
                </v-btn>
            </div>
        </v-col>
    </v-content>
</template>

<script>
import TreeChart from "../shared/components/treeChart";
import audioSelector from "../shared/components/audioSelector";
import ivrRepeat from "../shared/components/ivrRepeat";
export default {
    name: "callTemplate",
    components: {
        TreeChart,
        audioSelector,
        ivrRepeat,
    },
    data() {
        return {};
    },
    created() {
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', { type_of_notification: 'call' });
        if (this.templateId && this.action == "update") {
            this.$store.dispatch("GET_TEMPLATE_BY_ID", this.templateId);
        }
    },
    computed: {
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST.results;
        },
        templateId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateTemplate" && this.templateId ? "update" : "create";
        },
        template: {
            get() {
                return this.$store.getters.CURRENT_TEMPLATE;
            },
            set(value) {
                this.$store.commit("SET_CURRENT_TEMPLATE", value);
            },
        },
        templates() {
            return this.$store.getters.TEMPLATES;
        },
    },
    methods: {
        saveTemplate() {
            const action_dispatch = this.action === "create" ? "CREATE_TEMPLATE" : "UPDATE_TEMPLATE";
            this.$store
                .dispatch(action_dispatch, this.template)
                .then(() => {
                    this.$toaster.success("Шаблон сохранен");
                    this.back();
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        back(){
            this.$router.push({ path: "/call-templates" });
        },
        filteredDataArray(data, item) {
            return data.filter((option) => {
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(item.name.toLowerCase()) >= 0;
            });
        },
    },
};
</script>

<style></style>
